<label [for]="question.id + '-select'" class="sr-only">
  {{ question.title }}
</label>
<div [ngClass]="{ 'other-input-container': isOtherSelected() }">
  @if (inTable) {
    <ng-select
      class="block w-full in-table-dropdown"
      searchable="false"
      [labelForId]="question.id + '-select'"
      [formControl]="control"
      clearable="false"
      [attr.title]="getSelectedTitle()"
      [attr.aria-label]="question.title"
      [attr.aria-expanded]="isDropdownOpen"
      (open)="onOpen()"
      (close)="onClose()"
      (change)="handleOnChange($event)"
      [placeholder]="'question.singleselectdropdown.placeholder' | translate"
      [appendTo]="getAppendToElement()"
      dropdownPosition="auto"
    >
      <ng-template ng-label-tmp let-clear="clear">
        <span class="dropdown-selected-label" [title]="getSelectedTitle()">
          {{
            getSelectedTitle() ||
              ("question.singleselectdropdown.placeholder" | translate)
          }}
        </span>
      </ng-template>

      <ng-option class="flex flex-row" [value]="''">
        <span class="dropdown-option-label">
          {{ "question.singleselectdropdown.placeholder" | translate }}
        </span>
      </ng-option>

      @for (alternative of question.alternatives; track $index) {
        <ng-option class="flex flex-row" [value]="alternative.id">
          <span class="dropdown-option-label">
            {{ alternative.title }}
          </span>
        </ng-option>
      }
    </ng-select>
  } @else {
    <ng-select
      class="block w-full single-select-dropdown-input-select"
      searchable="false"
      [labelForId]="question.id + '-select'"
      [formControl]="control"
      clearable="false"
      [attr.title]="getSelectedTitle()"
      [attr.aria-label]="question.title"
      [attr.aria-expanded]="isDropdownOpen"
      (open)="onOpen()"
      (close)="onClose()"
      (change)="handleOnChange($event)"
      [placeholder]="'question.singleselectdropdown.placeholder' | translate"
    >
      <ng-template ng-label-tmp let-clear="clear">
        <span class="dropdown-selected-label" [title]="getSelectedTitle()">
          {{
            getSelectedTitle() ||
              ("question.singleselectdropdown.placeholder" | translate)
          }}
        </span>
      </ng-template>

      <ng-option class="flex flex-row" [value]="''">
        <span class="dropdown-option-label">
          {{ "question.singleselectdropdown.placeholder" | translate }}
        </span>
      </ng-option>

      @for (alternative of question.alternatives; track $index) {
        <ng-option class="flex flex-row" [value]="alternative.id">
          <span class="dropdown-option-label">
            {{ alternative.title }}
          </span>
        </ng-option>
      }
    </ng-select>
  }

  @if (otherControl && isOtherSelected()) {
    <div class="">
      <input
        #otherInput
        class="w-full px-2 py-1 focus:outline-none border-0 bg-transparent"
        type="text"
        role="textbox"
        id="otherInput"
        [formControl]="otherControl"
        [attr.aria-label]="'question.singleselect.otherinputlabel' | translate"
      />

      <div class="flex justify-between">
        <div>
          @if (otherControl.hasError("maxLength") && otherControl.touched) {
            <app-validator
              [question]="question"
              [validator]="ValidatorType.MaxLength"
              [control]="otherControl"
            ></app-validator>
          }
          @if (otherControl?.hasError("required") && otherControl.touched) {
            <app-validator
              [question]="question"
              [validator]="ValidatorType.RequiredText"
              [control]="otherControl"
            ></app-validator>
          }
        </div>
        <p
          class="text-xs pl-2 pr-2 pt-2"
          [ngClass]="{
            'validation-dynamic-theme': otherControl.value?.length > 255,
          }"
        >
          <span aria-hidden="true">
            {{ otherControl.value?.length ?? 0 }}/255</span
          >
        </p>
      </div>
    </div>
  }
  @if (
    control && control?.hasError("required") && control.touched && !hideError
  ) {
    <app-validator
      [question]="question"
      [validator]="ValidatorType.RequiredSelect"
    ></app-validator>
  }
  @if (control?.hasError("QuotaError") && control.touched) {
    <app-validator
      [question]="question"
      [validator]="ValidatorType.QuotaError"
      [control]="control"
    />
  }
</div>
